import Form from '@arivaa-react/components/form';

export function EditFooterContactUs() {
  const handleSubmit = async (values) => {
    console.log(values);
  };
  return (
    <div className="card">
      <div className="heading">
        <p className="label">Edit Contact Us</p>
      </div>
      <div className="edit-form">
        <Form
          renderForm={({ renderElement }) => {
            return (
              <div>
                <div className="item">
                  {renderElement({
                    type: 'text',
                    name: 'title',
                    label: 'Phone',
                    required: true,
                    options: {
                      initialValue: '',
                    },
                  })}
                </div>
                <div className="item">
                  {renderElement({
                    type: 'textarea',
                    name: 'address',
                    label: 'Address',
                    required: true,
                    options: {
                      initialValue: 'Home',
                    },
                  })}
                </div>
                <div className="item">
                  {renderElement({
                    type: 'text',
                    name: 'title',
                    label: 'Email',
                    required: true,
                    options: {
                      initialValue: '',
                    },
                  })}
                </div>
              </div>
            );
          }}
          onSubmit={handleSubmit}
          submitButtonProps={{
            children: 'Save',
          }}
        />
      </div>
    </div>
  );
}
